import { render, staticRenderFns } from "./ResetPasswordSentPage.vue?vue&type=template&id=435f2ab8&scoped=true"
import script from "./ResetPasswordSentPage.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordSentPage.vue?vue&type=script&lang=ts"
import style0 from "./ResetPasswordSentPage.vue?vue&type=style&index=0&id=435f2ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435f2ab8",
  null
  
)

export default component.exports